// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-Nummer {
  width: 110px;
  max-width: 110px;
  word-wrap: break-word;
}

.mat-column-TableButtons {
  width: 120px;
  max-width: 120px;
  word-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/app/util/components/akt-geraete-list/akt-geraete-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;AACF;;AACA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;AAEF","sourcesContent":[".mat-column-Nummer {\n  width: 110px;\n  max-width: 110px;\n  word-wrap: break-word;\n}\n.mat-column-TableButtons {\n  width: 120px;\n  max-width: 120px;\n  word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
